import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[mbsInputErrors]'
})
export class InputErrorsDirective {
  templateRef = inject<TemplateRef<any>>(TemplateRef);
}
